import React, { useContext, useState } from 'react'
import GameButton from '../../Components/GameButton/GameButton'
import { Game } from '../../Components/Game/Game'
import './Games.css'

type GameObject = {
    title: string,
    images: string[] // source paths
    tags: string[]
    overview: string
    skills: string
    technical: string
    playLink: string
    codeLink: string
}

const games: GameObject[] = [
    {
        title: 'GirlxDescent',
        images: ['girl_1', 'girl_2', 'girl_3'],
        tags: ['Unity', 'Shaders', 'Deck-builder', 'Run-and-gun', 'Particle effects'],
        overview: 'GirlxDescent is a arcade-style side-scroller with a deck-building mechanic, built for the month-long Magical Girl Game Jam with another programmer and an artist.',
        skills: 'I designed and programmed the deck-building mechanic where the player selects cards to give special abilities before each level. I also built the level management system, dialog system, and implemented particle effects and a wind shader.',
        technical: '',
        playLink: 'https://alirie.itch.io/girlxdescent',
        codeLink: 'https://github.com/AlirieGray/GirlxDescent'
    },
    {
        title: "Portals 'n Dragons",
        images: ['wizard_1', 'wizard_2', 'wizard_4', 'wizard_3'],
        tags: ['Unreal', 'Top-down', 'Roguelike'],
        overview: 'My first game in Unreal engine, a Vampire Survivors-style rougelike made with two other developers for a class project.',
        skills: 'I developed the enemy logic including spawning and following the player, and the loot drop and leveling-up system which gave players upgrades to their abilities as they picked up loot from killed enemies. I also programmed a "gravity bomb" ability, which was a projectile that sucked nearby enemies into its orbit when it hit the ground.',
        technical: '',
        playLink: 'https://alirie.itch.io/dragons-portals',
        codeLink: ''
    },
    // {
    //      title: 'Synthera',
    //      images: ['synthera_1', 'synthera_2'],
    //      tags: ['Unreal', 'Automation', 'First-person', 'Survival'],
    //      overview: 'My current project, a first-person survival automation game made for a class project in Unreal with a team of 15 student developers.',
    //      skills: 'As the lead programmer on the project, I have worked on enemy logic, a "programmable robot" system where players can set commands for robots to do resource-gathering tasks, and a crafting system. I work closely with artists and designers to ensure a cohesive vision and maintain documentation and a project management task board to keep the production process smooth.',
    //      technical: '',
    //      playLink: '',
    //      codeLink: 'https://github.com/Liamschoolprogramming/Game-Tech-2',
    //  },
]

function Games () {
    const [activeGamePosition, setActiveGame] = useState(0)
    const activeGame = games[activeGamePosition]

    const handleSetActiveGame = (i: number) => {
        setActiveGame(i)
    }

    return (<div className='gamesWrapper'>
    <div className='gamesButtonsWrapper'>
        <div className='gamesButtons'>
        {games.map(({title}, i) => (
            <GameButton title={title} position={i} setActiveGame={() => {handleSetActiveGame(i)}} isActive={i===activeGamePosition}/>
        ))}
        </div>
    </div>
    <div className='gamesContent'>
        { (activeGamePosition==0) && (<Game
            overview={activeGame.overview}
            images={activeGame.images}
            tags={activeGame.tags}
            technical={activeGame.technical}
            skills={activeGame.skills}
            playLink={activeGame.playLink}
            gitLink={activeGame.codeLink}
        />)}
            { (activeGamePosition==1) && (<Game
            overview={activeGame.overview}
            images={activeGame.images}
            tags={activeGame.tags}
            technical={activeGame.technical}
            skills={activeGame.skills}
            playLink={activeGame.playLink}
            gitLink={activeGame.codeLink}
        />)}
            { (activeGamePosition==2) && (<Game
            overview={activeGame.overview}
            images={activeGame.images}
            tags={activeGame.tags}
            technical={activeGame.technical}
            skills={activeGame.skills}
            playLink={activeGame.playLink}
            gitLink={activeGame.codeLink}
        />)}
    </div>
    </div>)
}

export default Games